module.exports = __webpack_public_path__ + "static/media/easy.d6e39918.png";